import React from 'react';
import { Navigate } from 'react-router-dom';
import { RoutePermittedRole } from '../../constants/AppEnums';

const PedidosDeVenta = React.lazy(
  () => import('../../../modules/blueSoft/Ventas/PedidosDeVenta'),
);
const EdicionPedidoDeVenta = React.lazy(
  () => import('../../../modules/blueSoft/Ventas/EdicionPedidoDeVenta'),
);
const MisVentas = React.lazy(
  () => import('../../../modules/blueSoft/Ventas/MisVentas'),
);
const Clientes = React.lazy(
  () => import('../../../modules/blueSoft/Ventas/Clientes'),
);
const EdicionCliente = React.lazy(
  () => import('../../../modules/blueSoft/Ventas/EdicionCliente'),
);
const Productos = React.lazy(
  () => import('../../../modules/blueSoft/Ventas/Productos/Productos'),
);
const ProductoVista = React.lazy(
  () => import('../../../modules/blueSoft/Ventas/Productos/ProductoVista'),
);
const AnalisisDeVentas = React.lazy(
  () => import('../../../modules/blueSoft/Ventas/AnalisisDeVentas'),
);
const Documento = React.lazy(
  () => import('../../../modules/blueSoft/Components/DocumentoView'),
);
const DocumentoPrint = React.lazy(
  () => import('../../../modules/blueSoft/Components/DocumentoPrintView'),
);
const NuevoCarrito = React.lazy(
  () => import('../../../modules/blueSoft/Carritos/NuevoCarrito'),
);
const CarritosPendientes = React.lazy(
  () => import('../../../modules/blueSoft/Ventas/CarritosPendientes'),
);

export const blueSoftPagesConfigs = [
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/inicio',
    element: <Navigate to='/blueSoft/carritos/NuevoCarrito' replace />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/documento/view',
    element: <Documento />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/documento/print',
    element: <DocumentoPrint />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/clientes/nuevo',
    element: <EdicionCliente />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/clientes/edicion',
    element: <EdicionCliente />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/clientes',
    element: <Clientes />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/producto/vista',
    element: <ProductoVista />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/productos',
    element: <Productos />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/pedidos',
    element: <PedidosDeVenta />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/pedidos/nuevo',
    element: <EdicionPedidoDeVenta />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/pedidos/edicion',
    element: <EdicionPedidoDeVenta />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/analisis',
    element: <AnalisisDeVentas />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/carritos/NuevoCarrito',
    element: <NuevoCarrito />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/carrito/pendientes',
    element: <CarritosPendientes />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/Ventas/MisVentas',
    element: <MisVentas />,
  },
];
